import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Mail, X, Loader } from 'lucide-react';
import api from '../utils/api';
import { toast } from 'sonner';

const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [verificationRequired, setVerificationRequired] = useState(true);

  useEffect(() => {
    // Fetch public app config to check if verification is required
    const fetchConfig = async () => {
      try {
        const res = await api.get('/public/app-config');
        setVerificationRequired(res.data.email_verification_required);
      } catch (error) {
        // Default to true if fetch fails
        setVerificationRequired(true);
      }
    };
    fetchConfig();
  }, []);

  // Don't show banner if:
  // - User is verified
  // - Banner is dismissed
  // - Email verification is not required globally
  if (!user || user.email_verified || dismissed || !verificationRequired) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    try {
      await api.post('/auth/resend-verification');
      toast.success('Verification email sent! Check your inbox.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to send verification email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-yellow-500/90 backdrop-blur-sm text-black px-4 py-3">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Mail className="w-5 h-5" />
          <span className="text-sm font-medium">
            Please verify your email to unlock all features (unlimited receipts, Pro subscription)
          </span>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={handleResend}
            disabled={sending}
            className="bg-black/20 hover:bg-black/30 text-black px-3 py-1 rounded-full text-sm font-medium transition-colors flex items-center space-x-1 disabled:opacity-50"
          >
            {sending ? (
              <>
                <Loader className="w-4 h-4 animate-spin" />
                <span>Sending...</span>
              </>
            ) : (
              <span>Resend Email</span>
            )}
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-black/20 rounded-full transition-colors"
            title="Dismiss for now"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
